<template>
  <div class="bg-gray-lighten1 p-12">
    <div class="container w-[664px] max-w-full">
      <div class="title mb-6 text-xl uppercase leading-none text-slate">
        {{ $t('subscribe_to_our_newsletter') }}
      </div>

      <client-only>
        <form
          class="flex w-full flex-col justify-between"
          @submit.prevent="submitForm"
        >
          <div class="mb-6 flex flex-col justify-between gap-4 md:flex-row">
            <span class="flex-grow">
              <UiInput
                v-model.trim="v$.email.$model"
                :placeholder="$t('enter_your_email')"
                :error="errorMessage(v$.email)"
                rounded="rounded-lg"
                required
                type="email"
              ></UiInput>
            </span>

            <div class="md:w-[210px]">
              <UiButton
                type="submit"
                size="lg"
                block
                fit-height
                class="h-[60px]"
                :disabled="isSubmitDisabled(v$.$invalid)"
              >
                {{ $t('subscribe') }}
              </UiButton>
            </div>
          </div>

          <UiCheckbox v-model="confirm" class="text-sm text-slate">
            <i18n-t keypath="i_agree_to" tag="span">
              <template #link>
                <UiLink to="/terms" class="text-blue underline-offset-2">
                  {{ $t('terms_of_subcription') }}
                </UiLink>
              </template>
            </i18n-t>
          </UiCheckbox>
        </form>
      </client-only>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import {
  useDomain,
  useForm,
  useSiteConfigState,
  useValidationRules,
} from '~/composables';

interface NewsletterSubscriptionForm {
  site: string;
  lang: string;
  email: string;
}

const { subscribeNewsLetterFormUuid } = useRuntimeConfig().public;
const { domain } = useDomain();
const { activeLanguage } = useSiteConfigState();

const { submit, isSubmitDisabled, confirm } = useForm({
  captcha: false,
});

const { required, email, errorMessage } = useValidationRules();

const formData = reactive<NewsletterSubscriptionForm>({
  site: domain.value as string,
  lang: activeLanguage.value as string,
  email: '',
});

const v$ = useVuelidate({ email: { required, email } }, formData);

const submitForm = async () => {
  const formId = subscribeNewsLetterFormUuid as string | undefined;
  await submit({ ...formData }, formId);
  confirm.value = false;
};
</script>
